<template>
	<div>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<b-modal ref="fileError"
			hide-footer
			title="Le fichier sélectionné ne convient pas"
			class="title-modal">
			<p class="my-4 text-modal">Il vous faut choisir un fichier audio qui ait une durée inférieure à la durée de votre vidéo, soit xx:xx.</p>
			<p class="my-4 text-modal">Les formats supportés sont les suivants : .mp3, .mp4, .flac</p>
		</b-modal>
		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<throbber />
			<p class="my-4">{{ loaderText }}</p>
		</b-modal>
		<div class="col-12 mt-4">
			<div class="row">
				<div class="col-12 col-lg-7">
					<div class="embed-responsive embed-responsive-16by9">
						<video class="embed-responsive-item"
							:src="videoUrl"
							ref="videoplayer"
							controls></video>
					</div>
				</div>
				<div class="col-12 col-lg-5">
					<div class="row">
						<input type="file"
							ref="defaultFileUpload"
							hidden
							accept="audio/*"> <label class="btn label btn-voice"
						style="margin-left:1rem;">Choisir un fichier audio <input type="file"
						id="file"
						ref="fileUpload"
						v-on:change="handleFileUpload()"
						hidden
						accept="audio/*"> </label>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div style="margin-top: 2rem;margin-right: 1rem; margin-left: 2rem;">
				<button type="submit"
					class="btn btn-valid"
					@click.prevent="sendDatas">Valider l'ensemble des modifications
				</button>
			</div>
			<div style="margin-top: 2rem;margin-left:1rem;">
				<a href="#"
					@click.prevent="goBack"
					:class="[isSaved ? 'btn btn-cancel' : ' btn btn-cancel']">Annuler l'insertion de la voix-off </a>
			</div>
		</div>
		<audio hidden
			controls
			:src="audio"
			ref="audioPlayer"></audio>
	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../event/event-bus.js";
import Throbber from "../ui/throbber.vue";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "VoiceOverEdition",
	components: {
		Throbber,
		lottie_error,
	},
	data() {
		return {
			videoUrl: "",
			text_error: "",
			isSaved: false,
			audio: "",
			videoName: "",
			uploadedFiles: [],
			loaderText: "",
		};
	},
	beforeRouteEnter(to, from, next) {
		axios.get(BASE_URL + "/public/api/stepAmbiances/" + to.params.stepId, {
			headers: {
				"Authorization": sessionStorage.getItem("auth"),
			},
		}).then(response => {
			next(vm => {
				let data = response.data.data;
				if (data.video !== undefined) {
					vm.videoUrl = data.video.url;
				}
			});
		});
	},
	methods: {
		recordVoice() {
		},
		handleFileUpload() {
			let $this = this;
			this.audio = "";
			let uploadFiles = $this.uploadedFiles;
			let inputFiles = $this.$refs.fileUpload.files;
			let videoPlayer = $this.$refs.videoplayer;
			if (["audio/mpeg", "audio/mp3", "audio/flac", "audio/mp4"].includes(inputFiles[0].type)) {
				this.isSaved = true;
				let audioPlayer = $this.$refs.audioPlayer;
				if (inputFiles.length >= 1) {
					for (let i = 0; i <= inputFiles.length - 1; i++) {
						$this.audio = URL.createObjectURL(inputFiles[i]);
						audioPlayer.onloadeddata = function () {
							if (audioPlayer.duration > videoPlayer.duration) {
								$this.$refs.fileError.show();
							}
							else {
								$this.uploadedFiles.push({
									id: i,
									filename: inputFiles[i].name,
									file: inputFiles[i],
									audio_duration: audioPlayer.duration,
								});
								$this.previewVoiceOver($this.$route.params.stepId);
							}
							URL.revokeObjectURL(inputFiles[i]);
						};
					}
				}
			}
			else {
				$this.$refs.fileError.show();
			}
			if (typeof uploadFiles !== "undefined" && uploadFiles instanceof Array) {
				if (uploadFiles.length >= 1) {
					uploadFiles.splice(0, 1);
				}
			}
		},
		previewVoiceOver(id) {
			let $this = this;
			$this.loaderText = "Veuillez patienter pendant la génération de votre prévisualisation de la voix-off";
			this.$refs.loaderModal.show();
			let bodyFormData = new FormData();
			bodyFormData.append("audio", this.uploadedFiles[0].file);
			axios.post(BASE_URL + "/public/api/stepAmbiances/" + id + "/previewVoiceOver",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function (response) {
				let data = response.data;
				$this.$refs.loaderModal.hide();
				$this.videoUrl = data.video_absolute_url + "#" + new Date().getTime();
				$this.videoName = data.videoName;
				EventBus.$emit("hasVoiceOver", true);
			});
		},
		sendDatas() {
			let $this = this;
			$this.loaderText = "Veuillez patienter pendant l'enregistrement de vos données";
			this.$refs.loaderModal.show();
			let bodyFormData = new FormData();
			bodyFormData.append("_method", "put");
			if (this.videoName !== undefined) {
				bodyFormData.append("videoName", this.videoName);
			}
			axios.post(BASE_URL + "/public/api/stepAmbiances/" + this.$route.params.stepId + "/updateVoiceOver",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderModal.hide();
				EventBus.$emit("isSaved", true);
				EventBus.$emit("hasVoiceOver", true);
				$this.$router.push({name: "ProjectEdition"});
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		goBack() {
			this.$router.push({name: "ProjectEdition"});
		},
	},
};
</script>

<style scoped>
.btn {
	margin-left: auto;
}

input[type=file] {
	position: absolute;
	top: 0;
	right: 0;
	min-width: 100%;
	min-height: 100%;
	font-size: 100px;
	text-align: right;
	filter: alpha(opacity=0);
	opacity: 0;
	outline: none;
	background: white;
	cursor: inherit;
	display: block;
}

input {
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #224B93 solid 1px;
}

.btn-cancel {
	background-color: var(--color-cancel);
	border-color: var(--color-cancel);
	color: var(--text-cancel);
}

.btn-valid {
	background: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
}

.label {
	background-color: #004FE9;
	color: #FFFFFF;
	margin-bottom: 1rem;
	margin-left: 15px;
	margin-right: 10px;
	padding: .375rem .5rem;
	cursor: pointer;
}

.btn-voice {
	cursor: pointer;
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
	margin-left: 0;
}

.title-modal {
	color: #BF1B28;
}

.text-modal {
	color: #224B93;
}
</style>
